module.exports = __webpack_public_path__ + "img/null.3c683971.png";